import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Message } from "primereact/message";

import { Dialog, DialogHeader, FormField } from "@/ds";

import {
  INACTIVATE_PAPEL_CARD_TITLE,
  INACTIVATE_PAPEL_CONFIRM_LABEL,
  INACTIVATE_PAPEL_JANELA_LABEL,
  INACTIVATE_PAPEL_MESSAGE,
  INACTIVATE_PAPEL_TITLE,
  JUSTIFICATIVA_LABEL,
  JUSTIFICATIVA_MAX_LENGTH,
  JUSTIFICATIVA_REQUIRED_HINT,
} from "./inativar-papel-obra-dialog.constants";
import styles from "./inativar-papel-obra-dialog.module.scss";
import type { InativarPapelObraDialogViewModel } from "./types-inativar-papel-obra-dialog";

export function InativarPapelObraDialogView({
  nome,
  janelaTexto,
  justificativa,
  serverError,
  isSubmitting,
  formId,
  confirmar,
  cancelar,
}: InativarPapelObraDialogViewModel) {
  return (
    <Dialog
      visible
      // O Prime acharia o primeiro botão do rodapé; o foco inicial é o `autoFocus` do campo.
      focusOnShow={false}
      size="lg"
      onHide={cancelar}
      locked={isSubmitting}
      header={
        <DialogHeader
          icon="power-off"
          tone="danger"
          title={INACTIVATE_PAPEL_TITLE}
          subtitle={INACTIVATE_PAPEL_MESSAGE}
          data-testid="inativar-papel-obra-message"
        />
      }
      footer={
        <div className={styles.footer}>
          <Button
            type="button"
            label="Cancelar"
            severity="secondary"
            text
            disabled={isSubmitting}
            onClick={cancelar}
            data-testid="inativar-papel-obra-cancel"
          />
          <Button
            type="submit"
            form={formId}
            label={INACTIVATE_PAPEL_CONFIRM_LABEL}
            severity="danger"
            loading={isSubmitting}
            data-testid="inativar-papel-obra-confirm"
          />
        </div>
      }
      data-testid="inativar-papel-obra-dialog"
    >
      <form id={formId} className={styles.body} onSubmit={confirmar} noValidate>
        <section
          className={styles.card}
          aria-labelledby="inativar-papel-obra-card-title"
          data-testid="inativar-papel-obra-details"
        >
          <span id="inativar-papel-obra-card-title" className={styles.cardLabel}>
            {INACTIVATE_PAPEL_CARD_TITLE}
          </span>
          <p className={styles.nome} data-testid="inativar-papel-obra-nome">
            {nome}
          </p>
          <div className={styles.dado}>
            <span className={styles.cardLabel}>{INACTIVATE_PAPEL_JANELA_LABEL}</span>
            <span className={styles.dadoValor} data-testid="inativar-papel-obra-janela">
              {janelaTexto}
            </span>
          </div>
        </section>

        <FormField.Root error={justificativa.error}>
          <div className={styles.labelRow}>
            <FormField.Label>{JUSTIFICATIVA_LABEL}</FormField.Label>
            <span className={styles.hint}>{JUSTIFICATIVA_REQUIRED_HINT}</span>
          </div>
          <FormField.Control>
            <InputTextarea
              autoFocus
              value={justificativa.value}
              rows={3}
              autoResize={false}
              maxLength={JUSTIFICATIVA_MAX_LENGTH}
              disabled={isSubmitting}
              required
              aria-required
              onChange={(event) => justificativa.digitar(event.currentTarget.value)}
              onBlur={justificativa.sairDo}
              data-testid="inativar-papel-obra-justificativa"
            />
          </FormField.Control>
          <FormField.Error data-testid="inativar-papel-obra-justificativa-error" />
        </FormField.Root>

        {serverError ? (
          <Message severity="error" text={serverError} data-testid="inativar-papel-obra-error" />
        ) : null}
      </form>
    </Dialog>
  );
}
